/* savecase-email-link-popup
 *
 * Handle clicks on a button in the layer
 * to "send email link to continue case later"
 * Use a alternate model for actual sending of email.
 *
 * NB: The model must be anon. access.
 *
 * Dependencies:
 *  Dialogue.js
 *  A model on the same server with the name:
 *    "{conf.template.savecase-email-link-popup.modelname} || emailsavecase"
 *  A layer on the same server with the name:
 *    "{conf.template.savecase-email-link-popup.layer}" || emailsavecase.html
 *
 * Author: Tim Bauwens
 * Copyright 2022 Berkeley Bridge
 *
 */

import { _, bb } from "$json";
import Dialogue from "$Dialogue";

((doc, $) => {
  let elem;
  let sessionid;
  const DICTIONARY = {
    "One moment please...": {
      "en": "One moment please...",
      "nl": "Een ogenblik alstublieft...",
      "en-GB": "One moment please..."
    },
    "Send continue later link": {
      "en": "Send continue later link",
      "nl": "Stuur link om later verder te gaan",
      "en-GB": "Send continue later link"
    },
    "A dialogue popup to retrieve your link to continue later, or email it to yourself":
      {
        "en": "A dialogue popup to retrieve your link to continue later, or email it to yourself",
        "nl": "Een dialoogpop-up om uw link op te halen om later verder te gaan, of deze naar uzelf te e-mailen",
        "en-GB":
          "A dialogue popup to retrieve your link to continue later, or email it to yourself"
      }
  };
  const dialogue = new Dialogue({
    "class": "p-savecase-email-popup-link-dialogue",
    "aria-label": _(
      "A dialogue popup to retrieve your link to continue later, or email it to yourself"
    )
  });
  const model = bb.propFinder(bb.conf)(
    "arbitrary.savecase-email-link-popup.modelname",
    "emailsavecase"
  );
  const layer = bb.propFinder(bb.conf)(
    "arbitrary.savecase-email-link-popup.layer",
    "emailsavecase.html"
  );
  const location = bb.propFinder(bb.conf)(
    "arbitrary.savecase-email-link-popup.location",
    `${window.location.protocol}//${window.location.host}${window.location.pathname}`
  );
  const handler = e => {
    if (
      e.target.classList.contains("p-savecase-email-link-popup-button") ||
      e.target.id === "p-savecase-email-link-popup-button"
    ) {
      e.stopPropagation();
      dialogue.render(elem);
    }
  };

  _.addTranslations(DICTIONARY);

  document.addEventListener("click", handler);

  $(doc).on("bb:finalHandleData", (e, data) => {
    if (data && data.groups && data.groups.length) {
      if (data.sessionid && data.sessionid !== sessionid) {
        sessionid = data.sessionid;
        let continuelink = encodeURIComponent(
          `${location}?modelid=${data.dbname}&sessionid=${sessionid}`
        );
        const callingmodel = bb.getVar("modelname");
        elem = document.createElement("div");
        elem.classList.add("p-savecase-email-link-popup");
        const iframe = document.createElement("iframe");
        iframe.title = _("Send continue later link");
        iframe.textContent = _("One moment please...");
        iframe.src = `${layer}?modelname=${model}&link=${continuelink}&callingmodel=${callingmodel}`;
        elem.append(iframe);
      }
    }
  });
})(document, jQuery);
